// Slow editorial marquee. Duplicated content for a seamless loop.
export default function Marquee({ items, className = "" }) {
  const content = [...items, ...items];
  return (
    <div className={`relative overflow-hidden ${className}`} data-testid="marquee">
      <div className="marquee-track animate-marquee">
        {content.map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-serif text-4xl sm:text-6xl lg:text-7xl font-bold text-forest-950/90 px-6">
              {item}
            </span>
            <span className="text-terracotta text-3xl sm:text-5xl">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
}
